import * as React from 'react'
import { Header } from '../components/Header'

export const SettingsHeader = () => {
  return <Header title="Settings" />
}
